import angular from 'angular'
import {
    taxpayerSetting
} from 'redevConfig'

const list = (taxpayerSetting && taxpayerSetting.list) || ''
const taxpayerSettingCtrl = list ? require(`redevelopment/system/taxpayerSetting/${list.controllerName}`) : require('./taxpayerSettingCtrl')
const taxpayerSettingTemp = list ? require(`redevelopment/system/taxpayerSetting/${list.templateName}`) : require('./view/taxpayerSetting.html')

export default angular
    .module('system.basedata.taxpayerSetting', [])
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider
            .state('system.basedata.taxpayerSetting', {
                abstract: true,
                url: '/taxpayerSetting',
                template: '<div ui-view></div>',
                title: '纳税人设置',
                default: 'system.basedata.taxpayerSetting.list',
            })
            .state('system.basedata.taxpayerSetting.list', {
                url: '/list',
                template: taxpayerSettingTemp,
                controller: 'taxpayerSettingCtrl',
            })
    }])
    .controller('taxpayerSettingCtrl', taxpayerSettingCtrl.default)
    .name


// WEBPACK FOOTER //
// ./src/app/system/basedata/taxpayerSetting/index.js